import { FC, ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from '../SidebarLayout/Header';

interface MainLayoutProps {
  children?: ReactNode;
}

export const MainLayout: FC<MainLayoutProps> = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        flex: 1,
        height: '100%',

        '.MuiPageTitle-wrapper': {
          background: theme.palette.mode === 'dark'
            ? theme.colors.alpha.trueWhite[5]
            : theme.colors.alpha.white[50],
          marginBottom: `${theme.spacing(4)}`,
          boxShadow: theme.palette.mode === 'dark'
            ? `0 1px 0 ${theme.colors.alpha.black[10]}`
            : `0 1px 0 ${theme.colors.alpha.black[10]}`
        }
      }}
    >
      <Header hasSidebar={false} />
      <Box
        sx={{
          position: 'relative',
          zIndex: 5,
          display: 'block',
          flex: 1,
          mt: theme.header.height,
          p: 3
        }}
      >
        <Box display="block">
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}; 